import type { JSX, ReactNode } from 'react';
import { useState } from 'react';
import { Card } from '@/components/ui/card';
import { Collapsible, CollapsibleContent } from '@/components/ui/collapsible';
import type { Experience, ExperienceStatus } from '../types/experience.types';
import { ExperienceCardBody, ExperienceCardHeader } from './ExperienceCardParts';

export interface ExperienceCardProps {
  experience: Experience;
  onEdit: (experience: Experience) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: ExperienceStatus) => void;
  renderExpandedContent?: (experience: Experience) => ReactNode;
}

export function ExperienceCard({
  experience,
  onEdit,
  onDelete,
  onStatusChange,
  renderExpandedContent,
}: ExperienceCardProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Collapsible open={isExpanded} onOpenChange={setIsExpanded}>
      <Card>
        <ExperienceCardHeader
          experience={experience}
          onEdit={() => onEdit(experience)}
          onDelete={() => onDelete(experience.id)}
          onStatusChange={(status) => onStatusChange(experience.id, status)}
          showTrigger={!!renderExpandedContent}
        />
        <ExperienceCardBody
          experience={experience}
          isExpanded={isExpanded}
          showTrigger={!!renderExpandedContent}
        />
        {renderExpandedContent && (
          <CollapsibleContent>{renderExpandedContent(experience)}</CollapsibleContent>
        )}
      </Card>
    </Collapsible>
  );
}
